import { cn } from "utils/cn";
import type { PageHeaderProps } from "./PageHeader.types";

export const PageHeader = ({
  title,
  titleAdornment,
  subtitle,
  meta,
  actions,
  className,
}: PageHeaderProps) => (
  // The title keeps at least 22rem. When the actions don't fit beside it, they wrap under it,
  // whatever the screen size or sidebar state.
  <header className={cn("flex flex-wrap items-start justify-between gap-x-4 gap-y-3", className)}>
    <div className="min-w-0 flex-[1_1_22rem]">
      <div className="flex min-w-0 flex-wrap items-center gap-3">
        <h1 className="break-words text-[48px] font-squada capitalize leading-10 text-foreground">
          {title}
        </h1>
        {titleAdornment}
      </div>
      {subtitle ? (
        <p className="mt-3 max-w-3xl text-left text-regular-2 text-muted-foreground">{subtitle}</p>
      ) : null}
      {meta ? <div className="mt-2 text-sm text-muted-foreground">{meta}</div> : null}
    </div>
    {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
  </header>
);
